<template>
  <div v-if="started && visible">
    <div class="time-good-price-container">
      <p class="text-time m-0">{{ $t("finishedIn") }}</p>
      <div class="count-down-container ml-5">
        <div class="btn-time">{{ time.days }}</div>
        <p style="font-weight: 1000; margin:0; padding:0">:</p>
        <div class="btn-time">{{ time.hours }}</div>
        <p style="font-weight: 1000; margin:0; padding:0">:</p>
        <div class="btn-time">{{ time.minutes }}</div>
        <p style="font-weight: 1000; margin:0; padding:0">:</p>
        <div class="btn-time">{{ time.seconds }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import LogoWGHN from "@/assets/img/logo/WGHN.png";
import LocationIcon from "@/assets/img/svg/location_icon.svg";
import FilterIcon from "@/assets/img/svg/filter_icon.svg";
import BannerVoucher from "@/assets/img/bannerVoucher.png";

export default {
  components: {},
  bodyClass: "home-page",
  props: {
    timeStartCountDown: {
      type: Number,
      default: 0
    },
    timeEndCountDown: {
      type: Number,
      default: 0
    },
    nameCountDown: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showDialog: false,
      showDialogFilter: false,
      images: {
        LogoWGHN,
        BannerVoucher
      },
      icons: {
        LocationIcon,
        FilterIcon
      },
      timeOut: 10000,
      remaining: 0,
      time1: null,
      visible: true
    };
  },
  computed: {
    started() {
      return Date.now() >= this.timeStartCountDown;
    },
    time: function() {
      const dist = this.remaining;
      const days = Math.floor(dist / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((dist % (1000 * 60)) / 1000);

      return { days, hours, minutes, seconds };
    }
  },
  watch: {},
  beforeDestroy() {
    this.stopCountdown();
  },
  created() {
    this.time1 = this.nameCountDown;
  },
  mounted() {
    if (this.started) {
      this.updateCountdown();
      this.time1 = setInterval(this.updateCountdown, 1000);
    }
  },
  beforeDestroy() {
    if (this.time1) {
      clearInterval(this.time1);
    }
  },
  methods: {
    updateCountdown() {
      const now = Date.now();
      this.remaining = this.timeEndCountDown - now;
      if (this.remaining <= 0) {
        this.visible = false;
        clearInterval(this.time1);
      }
    },

    stopCountdown() {
      clearInterval(this.time1);
    }
  }
};
</script>
<style></style>

<style scoped lang="scss">
.time-good-price-container {
  .count-down-container {
    display: flex;
    align-items: center;
    border: none !important;
  }
  .text-time {
    font-size: 12px;
  }
  .btn-time {
    padding: 0;
    margin: 0;
    width: 30px;
    height: 30px;
    background: #e31d1d;
    color: #fff;
    font-weight: 500;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 80px;
  }

  .time-good-price-container {
    .text-time {
      font-size: 10px;
    }
    .btn-time {
      width: 20px !important;
      height: 20px !important;
      background: #e31d1d;
      font-size: 10px;
      color: #fff;
      font-weight: 1000;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>
